module.exports = __webpack_public_path__ + "static/media/world-bg.1007be25.png";